export default function checkWebMSupport() {
  const elem = document.createElement('video');
  const webmTypes = [
    'video/webm; codecs="vp9, opus"',
    'video/webm; codecs="vp9, vorbis"',
    'video/webm; codecs="vp9"',
    'video/webm; codecs="vp8, opus"',
    'video/webm; codecs="vp8, vorbis"',
    'video/webm; codecs="vp8"'
  ];

  return !!elem.canPlayType && webmTypes.some((type) => elem.canPlayType(type) !== '');
}
